import { render, staticRenderFns } from "./VentasProcesadas.vue?vue&type=template&id=0cabc5dc"
import script from "./VentasProcesadas.vue?vue&type=script&lang=js"
export * from "./VentasProcesadas.vue?vue&type=script&lang=js"
import style0 from "./VentasProcesadas.vue?vue&type=style&index=0&id=0cabc5dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports